var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hidden-sm-and-up bg"},[_c('div',{staticClass:"mobile_callme_wrap"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.globalDicts['icp'])}})]),_c('div',{staticClass:"navigate_wrap"},_vm._l((_vm.linkList),function(link){return _c('a',{attrs:{"href":link.url}},[_vm._v(_vm._s(link.linkName))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }